module.exports = __webpack_public_path__ + "img/under-construction.80bec30c.png";